module.exports = __webpack_public_path__ + "static/media/fbtb_how_it_works.9aee6735.png";